import { useState } from 'react';

export const EngineeringCredit = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a 
      href="https://www.vesper-marketing.com" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="inline-flex items-center text-white/50 uppercase tracking-[0.15em] text-[8px] sm:text-[10px] sm:tracking-[0.2em] hover:text-white/70 transition-colors duration-300 whitespace-nowrap"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span>Engineered by</span>
      <span 
        className="relative ml-1.5 overflow-hidden inline-flex items-center"
        style={{ 
          width: isHovered ? '24ch' : '4ch', 
          height: '1.4em',
          transition: 'width 300ms ease-in-out' 
        }}
      >
        <span 
          className="absolute inset-0 flex items-center transition-all duration-300 ease-in-out"
          style={{
            transform: isHovered ? 'translateY(-100%)' : 'translateY(0)',
            opacity: isHovered ? 0 : 1
          }}
        >
          <span className="font-bold" style={{ color: '#A78BFA' }}>VM</span>
        </span>
        <span 
          className="absolute inset-0 flex items-center transition-all duration-300 ease-in-out whitespace-nowrap"
          style={{ 
            color: '#A78BFA',
            transform: isHovered ? 'translateY(0)' : 'translateY(100%)'
          }}
        >
          <span className="font-bold">Vesper Marketing</span>
        </span>
      </span>
    </a>
  );
};
